import React, { useContext } from 'react';
import c from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ErrorBoundary from '../../ErrorBoundary';
import BasicUserLink from '../_partials/BasicUserLink/BasicUserLink';
import BasicUserName from '../BasicUserName';
import s from './UserLink.scss';
export var UserLink = function (_a) {
    var user = _a.user, showSymbol = _a.showSymbol, symbolClassName = _a.symbolClassName, useCoreRibbon = _a.useCoreRibbon, coreRibbonClassname = _a.coreRibbonClassname, usernameClassName = _a.usernameClassName, linkTo = _a.linkTo, className = _a.className, biData = _a.biData, children = _a.children, tabIndex = _a.tabIndex, dataHook = _a["data-hook"];
    var isMobile = useContext(MobileContext);
    // in some cases this could be null, example deviation.author
    if (!user) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "UserLink" },
        React.createElement(BasicUserLink, { user: user, linkTo: linkTo, className: c(className, useCoreRibbon && s['with-svg-core-badge']), biData: biData, tabIndex: tabIndex, "data-hook": dataHook }, children ? (children) : (React.createElement(BasicUserName, { user: user, showSymbol: showSymbol, symbolOpensPopup: !isMobile, symbolClassName: symbolClassName, useCoreRibbon: useCoreRibbon, coreRibbonClassname: coreRibbonClassname, usernameClassName: usernameClassName })))));
};
UserLink.displayName = 'UserLink';
export default UserLink;
//# sourceMappingURL=UserLink.js.map